import React, {Suspense, useEffect} from "react";
import {Route, Switch} from "react-router-dom";
import {inject, observer} from "mobx-react";
import Header from "../Components/Layout/Header";
import Footer from "../Components/Layout/Footer";
import Loading from "../Components/Loading/Loading";
import Messages from "./Messages";
import Popup from "../Components/Popup/Popup";

const Dashboard = React.lazy(() => import('./Dashboard'));
const Product = React.lazy(() => import('./Product'));
const Category = React.lazy(() => import('./Category'));
const Articles = React.lazy(() => import('./Articles'));
const Article = React.lazy(() => import('./Article'));
const Pages = React.lazy(() => import('./Pages'));
const Contact = React.lazy(() => import('./Contact'));
const Department = React.lazy(() => import('./Department'));
const Departments = React.lazy(() => import('./Departments'));
const Search = React.lazy(() => import('./Search'));
const Works = React.lazy(() => import('./Works'));

const Info = React.lazy(() => import('./Info'));
const Error = React.lazy(() => import('./Error'));

const Main = (props) => {

    useEffect(() => {
        props.Settings.init();
    }, []);

    useEffect(() => {

        if( props.Settings.campaigns && props.Settings.campaigns.id_place === 1) {

        }

    }, [props.Settings]);

    if (props.Settings.loading) {
        return <Loading/>
    }

    return (
        <>
            <Header/>

            <main className="container--height">
                <Suspense fallback={<Loading/>}>
                    <Popup item={props.Settings.item?.campaigns[0]} />
                    <Switch>
                        <Route exact path={`/error`} component={(props) => <Error {...props}/>}/>
                        <Route exact path={`/info`} component={(props) => <Info {...props}/>}/>
                        <Route exact path={`/newsletter`}/>
                        <Route exact path={`/info/:slug`} component={(props) => <Pages {...props}/>}/>
                        <Route exact path={`/szukaj`} component={(props) => <Search {...props}/>}/>
                        <Route exact path={`/oddzial`} component={(props) => <Departments {...props}/>}/>
                        <Route exact path={`/oddzial/:slug`} component={(props) => <Department {...props}/>}/>
                        <Route exact path={`/kontakt`} component={(props) => <Contact {...props}/>}/>
                        <Route exact path={`/komunikaty`} component={(props) => <Messages {...props}/>}/>
                        <Route exact path={`/praca`} component={(props) => <Works {...props}/>}/>
                        <Route exact path={`/aktualnosci`} component={(props) => <Articles {...props}/>}/>
                        <Route exact path={`/aktualnosci/:slug`} component={(props) => <Article {...props}/>}/>
                        <Route exact path={`/produkt/:slug`} component={(props) => <Product {...props} />}/>
                        <Route exact path={`/:slug`} component={(props) => <Category {...props}/>}/>
                        <Route path={`/`} component={() => <Dashboard/>}/>
                    </Switch>
                </Suspense>
            </main>
            <Footer/>
        </>
    )
}

export default inject('Settings', 'Notification')(observer(Main))
